import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { formatPhoneNumber } from 'Utils/inputUtils'
import LookupLink from 'Components/LookupLink'
import {
  _MobileAgentCard, _AgentImage, _SeparatorLine,
  _AgentName, _AgentTitle, _AgentPhone, _AgentBrokerageName, _ContactBtn, _MobileAgentContainer, _MLSInfo,
} from './styles'


const MobileAgentCard = ({ agent, listing, handleContactAgentClick, isBuildingPage }) => {
  // different agent on server and client breaks hydration so hide on server
  const [showCard, setShowCard] = useState(false)
  useEffect(() => {
    setShowCard(true)
  }, [])
  if(!showCard) return ''

  const agentPhotoObj = agent && agent.profile_image
  const agentPhotoUrl =
    agentPhotoObj &&
    (agentPhotoObj.thumb_path ||
      agentPhotoObj.small_path ||
      agent.profile_image)

  const { fullname, title, cell, url, id, brokerage_name: brokerageName } = agent || {}
  const { mls_number: mlsNumber, brokerage: listingBrokerage } = listing || {}

  return (
    <_MobileAgentContainer>
      <_SeparatorLine />
      <_MobileAgentCard>
        <_AgentImage
          style={{
            backgroundImage: `url("${agentPhotoUrl}"), url("/static/images/person_placeholder.webp")`,
          }}
        />
        <div>
          <LookupLink
            to={`/${url}`}
            componentData={{ component: 'Agent', id, pageData: agent }}
          >
            <_AgentName>{fullname}</_AgentName>
          </LookupLink>
          <_AgentTitle>{title}</_AgentTitle>
          {
            brokerageName && brokerageName.includes('Property') ?
              <_AgentBrokerageName>
                {brokerageName}
              </_AgentBrokerageName>
              : ''
          }
          <_AgentPhone>
            <a href={`tel:${cell}`}>{formatPhoneNumber(cell)}</a>
          </_AgentPhone>
        </div>
      </_MobileAgentCard>
      <_ContactBtn
        secondary
        onClick={() => handleContactAgentClick('Mobile Agent Card', agent)}
      >
        Contact Agent
      </_ContactBtn>
      {listing?.offer !== 'Precon' &&
        <_MLSInfo>
          <div>© Property.ca Inc., Brokerage</div>
          { !isBuildingPage && (
            <>
              <div>{`MLS#: ${mlsNumber}`}</div>
              <div>{`Listed by ${listingBrokerage || '-'}`}</div>
            </>
          )
          }
        </_MLSInfo>
      }
    </_MobileAgentContainer>
  )
}


MobileAgentCard.propTypes = {
  agent: PropTypes.shape({
    profile_image: PropTypes.shape({}),
    id: PropTypes.number,
  }),
  listing: PropTypes.shape({
    brokerage: PropTypes.string,
    mls_number: PropTypes.string,
    offer: PropTypes.string,
  }),
  handleContactAgentClick: PropTypes.func,
  isBuildingPage: PropTypes.bool,
}

export default MobileAgentCard
